export default {
  mounted(){
    this.resizeEvent(false,'map_box','map_box_two');
    this.dragObject={
      dragging:(newRects,myPieChart)=>{
            if(newRects.left>1||newRects.left<-1){//开始移动
              if(this.firstFlag){//首次画图片

                //图片
                let resultBase64  = myPieChart.getDataURL({
                  type: 'png',
                  pixelRatio: 1,  //放大两倍下载，之后压缩到同等大小展示。解决生成图片在移动端模糊问题
                  backgroundColor: 'rgba(0,0,0,0)'
                });

                setTimeout(()=>{
                  this.showImgLabel = true;
                  this.result_img_url = resultBase64;
                  this.firstFlag=false;
                },50)
              }
            }
      },
      dragstop:(newRects,type,myPieChart,echartflag)=>{
        if(newRects.left>1||newRects.left<-1){
          this.newRect.width=1150;
          this.newRect.height=750;
          this.newRect.top=166;
          this.newRect.left=385;
          this.dragFlag=true;//添加背景色
          this.$nextTick(()=>{
              document.documentElement.style.fontSize = 130 + "px";
              myPieChart.resize()
              myPieChart.setOption({
                legend:{
                  itemGap:50,
                  textStyle:{
                    fontSize:24,
                  }
                },
              })
              if(type==2){//柱状图或者折线图
                  myPieChart.setOption({
                    yAxis: {
                        splitLine: {
                            lineStyle: {
                                color: "#6F93C5"
                            }
                        },
                    },
                })
              }
              if(echartflag){//回调函数
                echartflag()
              }

          })
        }else{
          // this.$nextTick(()=>{
          //      $('div.vdr').removeClass('active').addClass('inactive')
          // })
        }
      },
      resizestop:(newRects,myPieChart)=>{
        this.$nextTick(()=>{
            document.documentElement.style.fontSize = 100*( newRects.width/800) + "px";
            myPieChart.resize();
        })
      },
      dragtoStart:(type,width,height,myPieChart,echartflag)=>{
        this.firstFlag=true;//判断画图片
        this.showImgLabel = false;//隐藏动画
        this.dragFlag=false;//去掉背景

        this.newRect.width=width;//恢复初始位置
        this.newRect.height=height;
        this.newRect.top=0;
        this.newRect.left=0;

        this.$nextTick(()=>{
            document.documentElement.style.fontSize = 100 + "px";
            $('div.vdr').removeClass('active').addClass('inactive')
            myPieChart.resize();
            myPieChart.setOption({
              legend:{
                itemGap:5,
                textStyle:{
                  fontSize:16,
                }
              },
            })
            if(type==2){
              myPieChart.setOption({
                yAxis: {
                    splitLine: {
                        lineStyle: {
                            color: "#1C5281"
                        }
                    },
                },
              })
            }
            if(echartflag){
              echartflag()
            }
        })
      },

    }
  },
  data(){
    return{
      dragObject:{},
      dragFlag:false,//背景色
      showImgLabel:false,//是否显示clone图片
      result_img_url:'',//clone图片url
      firstFlag:true,//clone图片只加载一次
      newRect:{
            // width: 0,
            // height: 0,
            // top: 0,
            // left: 0
      },//初始宽高
    }
  },
  methods:{

      //千分位分隔符
      ThousandsSeparator: function(str = ''){
        var str_n=str.toString();
        if(str_n.includes('.')){
        return	parseFloat(str_n).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      }else{
        var result="";
        while(str_n.length>3){
          result=","+str_n.slice(-3)+result;
          str_n=str_n.slice(0,str_n.length-3)
        }
        if(str_n){
          return str_n+result
        }
      }

      },
      findKey: function (value, data, compare = (a, b) => a === b) {
        return Object.keys(data).find(k => compare(data[k], value))
      },
      //缩放
      resizeEvent: function(base,dom,dom2){

        window.onresize = function(){

          _GXResizeEvent(base);
          GXResizeEvent(dom,dom2);
        };
        _GXResizeEvent(base);
        GXResizeEvent(dom,dom2);

        function _GXResizeEvent() {
          var nDefault_width = 1920,
            nDefault_height = 1080,
            nClient_width = document.documentElement.clientWidth,
            nClient_height = document.documentElement.clientHeight,
            nAuot_width =  nClient_width /nDefault_width,
            nAuot_height =  nClient_height /nDefault_height,

            jNodeBody = document.body
          ;

          //jNodeBody.style.zoom = nAuot_width;
          jNodeBody.style.transform = "scale(" + nAuot_width + ","+ nAuot_height +")";
          jNodeBody.style.msTransform = "scale(" + nAuot_width + ","+ nAuot_height +")";
          jNodeBody.style.mozTransform = "scale(" + nAuot_width + ","+ nAuot_height +")";
          jNodeBody.style.webkitTransform = "scale(" + nAuot_width + ","+ nAuot_height +")";
          jNodeBody.style.oTransform = "scale(" + nAuot_width + ","+ nAuot_height +")";
        //  if(base2){
          //   let flag=false;
          //   $('.propertyRight').on('click','.ivu-select',function(){
          //     $('.ivu-select-dropdown').css('display','none')
          //     flag=!flag;
          //     if(flag){
          //       setTimeout(()=>{
          //         let nDefault_width = 1920,
          //           nDefault_height = 1080,
          //           nClient_width = document.documentElement.clientWidth,
          //           nClient_height = document.documentElement.clientHeight,
          //           nAuot_width =  nClient_width /nDefault_width,
          //           nAuot_height =  nClient_height /nDefault_height;
          //         let left=parseInt($('.ivu-select-dropdown').css('left'))/nAuot_width;
          //         let top=parseInt($('.ivu-select-dropdown').css('top'))/nAuot_height;
          //         $('.ivu-select-dropdown').css({"left":left,"top":top,'display':'block'}).attr('x-placement','bottom');
          //         $('.ivu-select-item').unbind("click").click(()=>{
          //           $('.ivu-select-dropdown').css('display','none')
          //           flag=!flag;
          //         });
          //
          //       },10)
          //     }
          //
          //
          // })
          //}


          if(base){
            //表格筛选弹框
            $('#innovateModal').on('click','.ivu-poptip',function(){
              let index=$("#innovateModal .ivu-poptip").index(this);
               $('.ivu-poptip-popper').css('display','none')
              clearTimeout(timer)
              var timer=setTimeout(()=>{
                var nDefault_width = 1920,
                  nDefault_height = 1080,
                  nClient_width = document.documentElement.clientWidth,
                  nClient_height = document.documentElement.clientHeight,
                  nAuot_width =  nClient_width /nDefault_width,
                  nAuot_height =  nClient_height /nDefault_height;
                let left=parseInt($('.ivu-poptip-popper:eq('+index+')').css('left'))/nAuot_width;
                let top=parseInt($('.ivu-poptip-popper:eq(0)').css('top'))/nAuot_height;
                 $('.ivu-poptip-popper:eq('+index+')').css({"left":left,"top":top,'display':'block'}).attr('x-placement','bottom').click(()=>{
                   $('.ivu-poptip-popper').css('display','none')
                 });
                 $('.ivu-modal-content').click(()=>{
                   $('.ivu-poptip-popper').css('display','none')
                 });

              },1);

            })
          }
        };

        function GXResizeEvent(dom,dom2) {//scale反算使用

            let nDefault_width = 1920,
                nDefault_height = 1080,
                nClient_width = document.documentElement.clientWidth,
                nClient_height = document.documentElement.clientHeight,
                nAuot_width =  nClient_width / nDefault_width,
                nAuot_height =  nClient_height / nDefault_height
            ;
          if(document.getElementById(dom)){
              document.getElementById(dom).style.transform = "scale(" + (1/nAuot_width).toFixed(2) + ","+ (1/nAuot_height).toFixed(2) +")";
              document.getElementById(dom).style.msTransform = "scale(" + (1/nAuot_width).toFixed(2) + ","+ (1/nAuot_height).toFixed(2) +")";
              document.getElementById(dom).style.mozTransform = "scale(" + (1/nAuot_width).toFixed(2) + ","+ (1/nAuot_height).toFixed(2) +")";
              document.getElementById(dom).style.webkitTransform = "scale(" + (1/nAuot_width).toFixed(2) + ","+ (1/nAuot_height).toFixed(2) +")";
              document.getElementById(dom).style.oTransform = "scale(" + (1/nAuot_width).toFixed(2) + ","+ (1/nAuot_height).toFixed(2) +")";
          }
          if(document.getElementById(dom2)){
              document.getElementById(dom2).style.transform = "scale(" + (1/nAuot_width).toFixed(2) + ","+ (1/nAuot_height).toFixed(2) +")";
              document.getElementById(dom2).style.msTransform = "scale(" + (1/nAuot_width).toFixed(2) + ","+ (1/nAuot_height).toFixed(2) +")";
              document.getElementById(dom2).style.mozTransform = "scale(" + (1/nAuot_width).toFixed(2) + ","+ (1/nAuot_height).toFixed(2) +")";
              document.getElementById(dom2).style.webkitTransform = "scale(" + (1/nAuot_width).toFixed(2) + ","+ (1/nAuot_height).toFixed(2) +")";
              document.getElementById(dom2).style.oTransform = "scale(" + (1/nAuot_width).toFixed(2) + ","+ (1/nAuot_height).toFixed(2) +")";
          }
        };
      },
  }
}



// WEBPACK FOOTER //
// ./src/mixin/index.js